import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { FormBuilder } from '@angular/forms';
import { Observable, Subscription, filter } from 'rxjs';
import moment from 'moment';
import { LANGUAGES } from 'src/app/conf/languages';
import { Lang } from 'src/app/model/lang';
import { Permission, PermittedCommand } from 'src/app/model/permission';
import * as PermissionActions from 'src/app/store/permissions/permissions.actions';
import { selectPermission, selectPermittedCommands } from 'src/app/store/permissions/permissions.selector';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';

@Component({
	templateUrl: './permission-info.dialog.component.html',
})

export class PermissionInfoDialogComponent implements OnInit, OnDestroy {
	permittedCommand$: Observable<PermittedCommand[] | undefined>;
	permittedCommandSub: Subscription | undefined;
	permission$: Observable<Permission | undefined>;
	permissionSub: Subscription | undefined;

	permission: Permission;
	permittedCommands: PermittedCommand[] = [];

	actionVisible: boolean;

	languages = LANGUAGES;
	flagImagePath = './assets/images/flags/';
	flagImageFormat = '.svg';

	oldStr: string;

	// design
	screenWidth: number;

	constructor(
		private fb: FormBuilder,
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		// Store selectors
		this.permittedCommand$ = this.store.select(selectPermittedCommands);
		this.permission$ = this.store.select(selectPermission);
	}

	ngOnInit(): void {
		if (this.config.data.permission) {
			this.permission = { ...this.config.data.permission };
			// we recall GET api for have updated infos
			this.store.dispatch(PermissionActions.getPermission({ permissionId: this.permission.Id }));
		} else {
			this.permission = new Permission();
		}

		this.subscribeAll();
		this.onResize();
	}

	ngOnDestroy(): void {
		this.permissionSub?.unsubscribe();
		this.permittedCommandSub?.unsubscribe();
	}

	subscribeAll(): void {
		this.permissionSub = this.permission$?.pipe(filter(p => !!p))
			.subscribe(p => {
				this.permission = p;
			}
		);
		this.permittedCommandSub = this.permittedCommand$.subscribe(permittedCommands => {
			this.permittedCommands = permittedCommands;
		});
	}

	setFirstDeviceName(cmdDevName: string): string {
		this.oldStr = cmdDevName;
		return cmdDevName;
	}

	getGroup(cmd): boolean {
		if (cmd.DeviceName !== this.oldStr) {
			this.oldStr = cmd.DeviceName;
			return true;
		} else {
			return false;
		}
	}

	getTime(date: Date): string {
		return moment(date).format('HH:mm');
	}

	getLanguage(code: Lang["code"]): string {
		let langName = '';
		LANGUAGES.forEach(lang => {
			if (code === lang.code) {
				langName = lang.name;
			}
		});
		return langName;
	}

	getColorStatus(status: string): string {
		switch (status) {
			case 'expired':
				return 'danger';
			case 'active':
				return 'success';
			case 'ready':
				return 'warning';
			default:
				return 'info';
		}
	}

	getCurrentLanguageFlag(customerLanguage): string {
		const currentLangFlagFile = this.flagImagePath + customerLanguage + this.flagImageFormat;
		return currentLangFlagFile;
	}

	closeDialog(): void {
		this.ref.close();
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}
}
